export default "__VITE_ASSET__DNF1LUag__"